 export default function numberToPhrase(value, currency = 'KGS') {
    var x = value.toFixed(2);
    if (x < 0 || x > 999999999999999.99) return false;

    currency = currency.trim().toUpperCase();

    if (currency !== 'KGS' && currency !== 'USD' && currency !== 'EUR') return false;

    var groups = [];

    groups[0] = {};
    groups[1] = {};
    groups[2] = {};
    groups[3] = {};
    groups[4] = {};

    groups[9] = {};

    groups[0][-1] = { 'KGS': 'сом', 'USD': 'долларов США', 'EUR': 'евро' };
    groups[0][1] = { 'KGS': 'сом', 'USD': 'доллар США', 'EUR': 'евро' };
    groups[0][2] = { 'KGS': 'сом', 'USD': 'доллара США', 'EUR': 'евро' };
    groups[0][3] = { 'KGS': 'сом', 'USD': 'доллара США', 'EUR': 'евро' };
    groups[0][4] = { 'KGS': 'сом', 'USD': 'доллара США', 'EUR': 'евро' };

    groups[1][-1] = 'тысяч';
    groups[1][1] = 'тысяча';
    groups[1][2] = 'тысячи';
    groups[1][3] = 'тысячи';
    groups[1][4] = 'тысячи';

    groups[2][-1] = 'миллионов';
    groups[2][1] = 'миллион';
    groups[2][2] = 'миллиона';
    groups[2][3] = 'миллиона';
    groups[2][4] = 'миллиона';

    groups[3][-1] = 'миллиардов';
    groups[3][1] = 'миллиард';
    groups[3][2] = 'миллиарда';
    groups[3][3] = 'миллиарда';
    groups[3][4] = 'миллиарда';

    groups[4][-1] = 'триллионов';
    groups[4][1] = 'триллион';
    groups[4][2] = 'триллиона';
    groups[4][3] = 'триллиона';
    groups[4][4] = 'триллиона';

    groups[9][-1] = { 'KGS': 'тыйын', 'USD': 'центов', 'EUR': 'центов' };
    groups[9][1] = { 'KGS': 'тыйын', 'USD': 'цент', 'EUR': 'цент' };
    groups[9][2] = { 'KGS': 'тыйын', 'USD': 'цента', 'EUR': 'цента' };
    groups[9][3] = { 'KGS': 'тыйын', 'USD': 'цента', 'EUR': 'цента' };
    groups[9][4] = { 'KGS': 'тыйын', 'USD': 'цента', 'EUR': 'цента' };

    var names = {};
    names[1] = { 0: 'один', 1: 'одна', 2: 'один', 3: 'один', 4: 'один' };
    names[2] = { 0: 'два', 1: 'две', 2: 'два', 3: 'два', 4: 'два' };
    names[3] = 'три';
    names[4] = 'четыре';
    names[5] = 'пять';
    names[6] = 'шесть';
    names[7] = 'семь';
    names[8] = 'восемь';
    names[9] = 'девять';
    names[10] = 'десять';
    names[11] = 'одиннадцать';
    names[12] = 'двенадцать';
    names[13] = 'тринадцать';
    names[14] = 'четырнадцать';
    names[15] = 'пятнадцать';
    names[16] = 'шестнадцать';
    names[17] = 'семнадцать';
    names[18] = 'восемнадцать';
    names[19] = 'девятнадцать';
    names[20] = 'двадцать';
    names[30] = 'тридцать';
    names[40] = 'сорок';
    names[50] = 'пятьдесят';
    names[60] = 'шестьдесят';
    names[70] = 'семьдесят';
    names[80] = 'восемьдесят';
    names[90] = 'девяносто';
    names[100] = 'сто';
    names[200] = 'двести';
    names[300] = 'триста';
    names[400] = 'четыреста';
    names[500] = 'пятьсот';
    names[600] = 'шестьсот';
    names[700] = 'семьсот';
    names[800] = 'восемьсот';
    names[900] = 'девятьсот';

    var result = '';
    var i, j;

    var y = Math.floor(x);

    if (y > 0) {
        var t = [];

        for (i = 0; i <= 4; i++) {
            t[i] = y % 1000;
            y = Math.floor(y / 1000);
        }

        var d = [];

        for (i = 0; i <= 4; i++) {
            d[i] = {};
            d[i][0] = t[i] % 10;
            d[i][10] = t[i] % 100 - d[i][0];
            d[i][100] = t[i] - d[i][10] - d[i][0];
            d[i][11] = t[i] % 100;
        }

        for (i = 4; i >= 0; i--) {
            if (t[i] > 0) {
                if (names[d[i][100]]) {
                    result += ' ' + ((typeof (names[d[i][100]]) == 'object') ? (names[d[i][100]][i]) : (names[d[i][100]]));
                }

                if (names[d[i][11]]) {
                    result += ' ' + ((typeof (names[d[i][11]]) == 'object') ? (names[d[i][11]][i]) : (names[d[i][11]]));
                } else {
                    if (names[d[i][10]]) {
                        result += ' ' + ((typeof (names[d[i][10]]) == 'object') ? (names[d[i][10]][i]) : (names[d[i][10]]));
                    }
                    if (names[d[i][0]]) {
                        result += ' ' + ((typeof (names[d[i][0]]) == 'object') ? (names[d[i][0]][i]) : (names[d[i][0]]));
                    }
                }

                if (names[d[i][11]]) {
                    j = d[i][11];
                } else {
                    j = d[i][0];
                }

                if (groups[i][j]) {
                    if (i === 0) {
                        result += ' ' + groups[i][j][currency];
                    } else {
                        result += ' ' + groups[i][j];
                    }
                } else {
                    if (i === 0) {
                        result += ' ' + groups[i][-1][currency];
                    } else {
                        result += ' ' + groups[i][-1];
                    }
                }
            }
        }

        if (t[0] === 0) {
            result += ' ' + groups[0][-1][currency];
        }
    } else {
        result = 'Ноль ' + groups[0][-1][currency];
    }

    y = ((x - Math.floor(x)) * 100).toFixed();
    if (y < 10) {
        y = '0' + y;
    }

    result = result.trim();
    result = result.substr(0, 1).toUpperCase() + result.substr(1);
    result += ' ' + y;

    y = y * 1;

    if (names[y]) {
        j = y;
    } else {
        j = y % 10;
    }

    if (groups[9][j]) {
        result += ' ' + groups[9][j][currency];
    } else {
        result += ' ' + groups[9][-1][currency];
    }

    return result;
}
